// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-strings/src/Data/String/Unsafe.js");
module.exports = {
    "char": $foreign["char"], 
    charAt: $foreign.charAt, 
    charCodeAt: $foreign.charCodeAt
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-strings/src/Data/String/Unsafe.purs
// module id = 108
// module chunks = 0